(() => {
  // Product page videos: small thumbnails rotate one at a time; tapping one opens
  // the full-screen player and plays ONLY that video, muted by default.
  // Swiping to another video pauses the last one and plays the new one.
  const videosRoot = document.querySelector('.tolstoy-app-videos');
  const popupList = document.querySelector('.tolstoy-app-videos-popup-lists');
  const popupContainer = document.querySelector('.tolstoy-app-videos-popup-container-fixed');
  const product = document.querySelector('.product');

  if (!videosRoot || !popupList || !popupContainer || !product) {
    return;
  }

  // Move the full-screen player to the end of the page so no animated/transformed
  // parent can trap it in a small box on mobile.
  if (popupContainer.parentElement !== document.body) {
    document.body.appendChild(popupContainer);
  }

  const thumbVideos = videosRoot.querySelectorAll('button video');
  const duration = parseInt(videosRoot.dataset.duration || '0', 10);
  let thumbIndex = 0;
  let popupOpen = false;
  let ignoreScrollUntil = 0;
  let scrollTimeout;

  const items = () => Array.from(popupList.querySelectorAll('.tolstoy-app-videos-popup-lists-item'));
  const itemAt = (index) => popupList.querySelector(`.tolstoy-app-videos-popup-lists-item.item-${index}`);
  const soundOn = () => {
    const icon = document.querySelector('.tolstoy-app-videos-popup-mute svg.not-muted');
    return !!(icon && icon.classList.contains('active'));
  };

  const safePlay = (video) => {
    if (!video) return;
    video.play().catch(() => {
      // Browser refused to play with sound: fall back to muted so it still autoplays.
      if (!video.muted) {
        video.muted = true;
        video.play().catch(() => {});
      }
    });
  };

  const removePlayIcon = (item) => {
    const icon = item && item.querySelector(':scope > svg');
    if (icon) icon.remove();
  };

  // ---- Thumbnail rotation (paused while the full-screen player is open) ----
  if (thumbVideos.length) {
    thumbVideos.forEach((v) => { v.muted = true; });
    safePlay(thumbVideos[0]);
    if (duration && thumbVideos.length > 1) {
      setInterval(() => {
        if (popupOpen) return;
        thumbVideos[thumbIndex].pause();
        thumbIndex = thumbIndex >= thumbVideos.length - 1 ? 0 : thumbIndex + 1;
        safePlay(thumbVideos[thumbIndex]);
      }, duration);
    }
  }

  const stop_videos = () => {
    popupList.querySelectorAll('.tolstoy-app-videos-popup-lists-item video').forEach((video) => video.pause());
  };

  const play_video = (index, type) => {
    const item = itemAt(index);
    if (!item) return;
    const video = item.querySelector('video');

    items().forEach((el) => el.classList.remove('active'));
    item.classList.add('active');
    removePlayIcon(item);

    // Pause everything else so only one video ever plays.
    stop_videos();

    // Our own scroll shouldn't trigger the swipe handler.
    ignoreScrollUntil = Date.now() + 800;
    item.scrollIntoView({ behavior: type === 'smooth' ? 'smooth' : 'auto', block: 'end', inline: 'nearest' });

    if (type !== '') video.currentTime = 0;
    video.muted = !soundOn();
    safePlay(video);
  };

  const show_video = (index) => {
    popupOpen = true;
    thumbVideos.forEach((v) => v.pause());
    product.classList.add('z-index-overlay');
    popupContainer.classList.add('active');
    // Wait one frame so the player is visible before scrolling to and playing the video.
    requestAnimationFrame(() => play_video(index, ''));
  };

  const hide_video = () => {
    popupOpen = false;
    product.classList.remove('z-index-overlay');
    popupContainer.classList.remove('active');
    stop_videos();
    if (thumbVideos.length) safePlay(thumbVideos[thumbIndex]);
  };

  const pause_video = (index) => {
    const item = itemAt(index);
    if (!item) return;
    const video = item.querySelector('video');
    if (video.paused) {
      play_video(index, '');
      return;
    }
    video.pause();
    if (!item.querySelector(':scope > svg')) {
      item.insertAdjacentHTML(
        'afterbegin',
        '<svg width="90" height="90" viewBox="0 0 120 120" fill="none" aria-hidden="true" style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);pointer-events:none;"><path d="M60 114.546c30.125 0 54.546-24.421 54.546-54.546S90.125 5.455 60 5.455 5.455 29.875 5.455 60 29.875 114.546 60 114.546Z" fill="#090A0B99"></path><path d="M50.387 85.167c-3.142 0-5.387-2.47-5.387-5.387V40.275C45 37.469 47.245 35 50.387 35c.898 0 1.908.224 2.806.786l32.322 19.752c1.571.898 2.581 2.694 2.581 4.49 0 1.907-1.01 3.703-2.581 4.6L53.193 84.382a5.33 5.33 0 0 1-2.806.786Z" fill="#fff"></path></svg>'
      );
    }
  };

  const mute_video = () => {
    document.querySelectorAll('.tolstoy-app-videos-popup-mute svg').forEach((svg) => svg.classList.toggle('active'));
    const active = popupList.querySelector('.tolstoy-app-videos-popup-lists-item.active video');
    popupList.querySelectorAll('.tolstoy-app-videos-popup-lists-item video').forEach((video) => { video.muted = true; });
    if (active) {
      active.muted = !soundOn();
      if (active.paused) safePlay(active);
    }
  };

  // Swiping: once scrolling settles, play the video that fills the screen most.
  popupList.addEventListener('scroll', () => {
    if (!popupOpen || Date.now() < ignoreScrollUntil) return;
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      const listBox = popupList.getBoundingClientRect();
      let best = null;
      let bestVisible = 0;
      items().forEach((item) => {
        const box = item.getBoundingClientRect();
        const visible = Math.min(box.bottom, listBox.bottom) - Math.max(box.top, listBox.top);
        if (visible > bestVisible) {
          bestVisible = visible;
          best = item;
        }
      });
      if (!best) return;
      const video = best.querySelector('video');
      if (best.classList.contains('active') && !video.paused) return;
      items().forEach((el) => el.classList.remove('active'));
      best.classList.add('active');
      removePlayIcon(best);
      stop_videos();
      video.muted = !soundOn();
      safePlay(video);
    }, 120);
  }, { passive: true });

  // When a video ends, move on to the next one.
  items().forEach((item, i, all) => {
    const video = item.querySelector('video');
    video.addEventListener('ended', () => {
      if (!popupOpen) return;
      const next = i + 2 > all.length ? 1 : i + 2;
      play_video(next, 'smooth');
    });
  });

  const run_video_progress = (video) => {
    const bar = video.parentElement && video.parentElement.querySelector('.progress .bar');
    if (bar && video.duration) bar.style.width = `${(video.currentTime / video.duration) * 100}%`;
  };

  const go_to = (type) => {
    const all = items();
    let i = all.findIndex((el) => el.classList.contains('active'));
    if (i < 0) i = 0;
    if (type === 'down') {
      i = i === all.length - 1 ? 0 : i + 1;
    } else {
      i = i === 0 ? all.length - 1 : i - 1;
    }
    play_video(i + 1, 'smooth');
  };

  document.addEventListener('keydown', (e) => {
    if (popupOpen && e.key === 'Escape') hide_video();
  });

  // Expose the handlers used by the inline onclick/ontimeupdate attributes in the
  // shoppable videos block and popup markup.
  Object.assign(window, {
    show_video,
    hide_video,
    stop_videos,
    pause_video,
    mute_video,
    play_video,
    run_video_progress,
    go_to,
  });
})();
